/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderPermissionSet, ContactType } from '@gh/builder-shared-data';
import {
  ContextRoute,
  getContextRouteInitData,
  getContextRouteParam,
} from '@gh/common-internal-shared';
import { UserContext } from '@gh/common-shared';
import { isString } from 'lodash';
import { ContactDetails } from '../resources/model/contact-details.model';

function getDefaultSlaveTabFor(master: string): string {
  return {
    'cityCounty': 'communications',
    'other': 'communications',
  }[master] || 'common';
}

@Injectable()
export class ContactDetailsModel {
  readonly creationMode: boolean;
  readonly viewMode: boolean;
  readonly skipOfficeSetupFlowCheck: boolean;

  readonly contactId: string;

  readonly parentRoute: string;
  readonly parentTitle: string;

  readonly contactType: ContactType;

  original: ContactDetails;

  masterTab: string = 'common';
  slaveTab?: string;

  constructor(route: ContextRoute, private userContext: UserContext) {
    const { parentRoute, parentTitle, contactType, show, skipOfficeSetupFlowCheck } = route.params;
    const contactId = getContextRouteParam(route, 'contactId');

    this.creationMode = !contactId;
    this.viewMode = !userContext.hasPermission(BuilderPermissionSet.Contacts.Details.CREATE_EDIT);
    this.skipOfficeSetupFlowCheck = skipOfficeSetupFlowCheck;

    this.contactId = contactId;
    this.parentRoute = parentRoute;
    this.parentTitle = parentTitle;

    this.contactType = contactType;

    if (show === 'sub-contractor') {
      this.masterTab = 'creditorSupplier';
      this.slaveTab = 'subContractor';
    }

    this.original = getContextRouteInitData(route).contact;
  }

  get editMode(): boolean {
    return !(this.creationMode || this.viewMode);
  }

  get queryParams(): Hash<any> {
    return {
      parentRoute: this.parentRoute,
      parentTitle: this.parentTitle,
      contactType: this.contactType,
    };
  }

  goToTab(path: string | string[]): void {
    if (isString(path)) {
      this.masterTab = path;
      this.slaveTab = getDefaultSlaveTabFor(path);
    } else {
      const [master, slave] = path;
      this.masterTab = master;
      this.slaveTab = slave;
    }
  }

  goToSubTab(name: string): void {
    this.slaveTab = name;
  }

  setOriginal(newModel: any): void {
    this.original = newModel;
  }

  getSlaveTabFor(tab: string): Maybe<string> {
    const { masterTab, slaveTab } = this;

    return masterTab === tab ? slaveTab : void 0;
  }
}
